import { isClient } from './envDetection';
export default function getURLSearchParams() {
    if (isClient()) {
        return new URLSearchParams(window.location.search);
    }

    return new URLSearchParams();
}
